import { render, staticRenderFns } from "./Void.vue?vue&type=template&id=5f3afba0"
import script from "./Void.vue?vue&type=script&lang=js"
export * from "./Void.vue?vue&type=script&lang=js"
import style0 from "./Void.vue?vue&type=style&index=0&id=5f3afba0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports